import React, { Component } from "react";
import { Col, Row, Container, Form } from "react-bootstrap";
import { AutoSuggestSelect } from "../../../component/AutoSuggestSelect";
import { TableTemplate } from "../../reusableComponent";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PermissionHOC from "../../PermissionHOC";
import { Link } from "react-router-dom";

// helpers
import { ERROR_MSG, STATUS, PATHS } from "../../../constant";
import { isValidArray, dateFormat, getLocalstorage } from "../../../helper";
import { get } from "lodash";

// actions
import {
  getAutoCompleteListAction,
  getAutoCompleteListUserAction
} from "../../../actions/createProject.action";
import {
  getMigrateProjectListAction,
  migrateProjectAction,
  clearMigrateDataAction,
  updateMigrateDataAction
} from "../../../actions/userManagement.action";
// contants
import { HEADERS } from "./migrateProjectConstant";
import { successToastStyle, errorToastStyle } from "../../../customToast";
class MigrateProject extends Component {
  state = {
    projectList: [],
    sourceoptions: [],
    targetOptions: [],
    projectListCount: null,
    sourceDefaultSelected: null,
    sourceAutoSuggestApiLoading: false,
    targetDefaultSelected: null,
    targetAutoSuggestApiLoading: false
  };

  componentWillUnmount() {
    this.props.clearMigrateDataAction();
  }

  onSourceAutoSuggestChange = value => {
    this.setState(
      {
        sourceUserID: null,
        sourceAutoSuggestApiLoading: true,
        sourceDefaultSelected: value.searchedText,
        sourceoptions: [],
        projectList: [],
        projectListCount: null
      },
      async () => {
        // reset the data
        const {
          props: { updateMigrateDataAction, migrateFormData }
        } = this;
        updateMigrateDataAction({
          ...migrateFormData,
          sourceUserID: null,
          projectList: []
        });
        // auto complete
        const resp = await getAutoCompleteListAction(
          undefined,
          value.searchedText
        );
        if (get(resp, "status") && isValidArray(get(resp, "data"))) {
          this.setState({
            sourceoptions: get(resp, "data"),
            sourceAutoSuggestApiLoading: STATUS.SUCCESS
          });
        } else {
          toast.error(
            <p className="toast-text-alignment">{ERROR_MSG.NO_DATA_FOUND}</p>,
            errorToastStyle
          );
          this.setState({
            sourceoptions: [],
            sourceAutoSuggestApiLoading: STATUS.SUCCESS
          });
        }
      }
    );
  };
  onSourceAutoSuggestChangeStatepmg = value => {
    this.setState(
      {
        sourceUserID: null,
        sourceAutoSuggestApiLoading: true,
        sourceDefaultSelected: value.searchedText,
        sourceoptions: [],
        projectList: [],
        projectListCount: null
      },
      async () => {
        // reset the data
        const {
          props: { updateMigrateDataAction, migrateFormData }
        } = this;
        updateMigrateDataAction({
          ...migrateFormData,
          sourceUserID: null,
          projectList: []
        });
        // auto complete
        const resp = await getAutoCompleteListUserAction(
          undefined,
          value.searchedText
        );
        if (get(resp, "status") && isValidArray(get(resp, "data"))) {
          this.setState({
            sourceoptions: get(resp, "data"),
            sourceAutoSuggestApiLoading: STATUS.SUCCESS
          });
        } else {
          toast.error(
            <p className="toast-text-alignment">{ERROR_MSG.NO_DATA_FOUND}</p>,
            errorToastStyle
          );
          this.setState({
            sourceoptions: [],
            sourceAutoSuggestApiLoading: STATUS.SUCCESS
          });
        }
      }
    );
  };
  onSourceOptionClick = value => {
    this.setState(
      {
        sourceUserID: value,
        sourceoptions: [],
        sourceDefaultSelected: `${value.name} (${value.userID})`
      },
      async () => {
        const {
          props: { updateMigrateDataAction, migrateFormData }
        } = this;
        updateMigrateDataAction({
          ...migrateFormData,
          sourceUserID: this.state.sourceUserID
        });
        const response = await this.props.getMigrateProjectListAction(
          undefined,
          value.id
        );
        this.setState(
          {
            projectList: response.data,
            projectListCount: response.data.length
          },
          () => {
            HEADERS[0].selectAll = false;
            this.onSelectAll();
          }
        );
      }
    );
  };
  onSourceOptionClickStatepmg = value => {
    this.setState(
      {
        sourceUserID: value,
        sourceoptions: [],
        sourceDefaultSelected: `${value.name} (${value.organization})`
      },
      async () => {
        const {
          props: { updateMigrateDataAction, migrateFormData }
        } = this;
        updateMigrateDataAction({
          ...migrateFormData,
          sourceUserID: this.state.sourceUserID
        });
        const response = await this.props.getMigrateProjectListAction(
          undefined,
          value.id
        );
        this.setState(
          {
            projectList: response.data,
            projectListCount: response.data.length
          },
          () => {
            HEADERS[0].selectAll = false;
            this.onSelectAll();
          }
        );
      }
    );
  };
  onTargetAutoSuggestChange = value => {
    this.setState(
      {
        targetUserID: null,
        targetAutoSuggestApiLoading: true,
        targetDefaultSelected: value.searchedText,
        targetOptions: []
      },
      async () => {
        const resp = await getAutoCompleteListAction(
          undefined,
          value.searchedText
        );
        if (get(resp, "status") && isValidArray(get(resp, "data"))) {
          this.setState({
            targetOptions: get(resp, "data"),
            targetAutoSuggestApiLoading: STATUS.SUCCESS
          });
        } else {
          // reset the data
          const {
            props: { updateMigrateDataAction, migrateFormData }
          } = this;
          updateMigrateDataAction({ ...migrateFormData, targetUserID: null });
          // error
          toast.error(
            <p className="toast-text-alignment">{ERROR_MSG.NO_DATA_FOUND}</p>,
            errorToastStyle
          );
          this.setState({
            targetOptions: [],
            targetAutoSuggestApiLoading: STATUS.SUCCESS
          });
        }
      }
    );
  };
  onTargetAutoSuggestChangeStatepmg = value => {
    this.setState(
      {
        targetUserID: null,
        targetAutoSuggestApiLoading: true,
        targetDefaultSelected: value.searchedText,
        targetOptions: []
      },
      async () => {
        const resp = await getAutoCompleteListUserAction(
          undefined,
          value.searchedText
        );
        if (get(resp, "status") && isValidArray(get(resp, "data"))) {
          this.setState({
            targetOptions: get(resp, "data"),
            targetAutoSuggestApiLoading: STATUS.SUCCESS
          });
        } else {
          // reset the data
          const {
            props: { updateMigrateDataAction, migrateFormData }
          } = this;
          updateMigrateDataAction({ ...migrateFormData, targetUserID: null });
          // error
          toast.error(
            <p className="toast-text-alignment">{ERROR_MSG.NO_DATA_FOUND}</p>,
            errorToastStyle
          );
          this.setState({
            targetOptions: [],
            targetAutoSuggestApiLoading: STATUS.SUCCESS
          });
        }
      }
    );
  };

  onTargetOptionClick = value => {
    const {
      props: { updateMigrateDataAction, migrateFormData }
    } = this;
    this.setState(
      {
        targetUserID: value,
        targetOptions: [],
        targetDefaultSelected: `${value.name} (${value.userID})`
      },
      () => {
        updateMigrateDataAction({
          ...migrateFormData,
          targetUserID: this.state.targetUserID
        });
      }
    );
  };
  onTargetOptionClickStatepmg = value => {
    const {
      props: { updateMigrateDataAction, migrateFormData }
    } = this;
    this.setState(
      {
        targetUserID: value,
        targetOptions: [],
        targetDefaultSelected: `${value.name} (${value.organization})`
      },
      () => {
        updateMigrateDataAction({
          ...migrateFormData,
          targetUserID: this.state.targetUserID
        });
      }
    );
  };
  onToggleCheckbox = index => {
    const {
      props: { updateMigrateDataAction, migrateFormData },
      state: { projectList }
    } = this;
    projectList[index].checked = !projectList[index].checked;
    HEADERS[0].selectAll =
      projectList.filter(val => val.checked).length === projectList.length;

    if (projectList[index].checked) {
      this.setState({ projectListCount: this.state.projectListCount + 1 });
    } else {
      this.setState({ projectListCount: this.state.projectListCount - 1 });
    }
    this.setState(
      {
        projectList: [...this.state.projectList]
      },
      () => {
        updateMigrateDataAction({
          ...migrateFormData,
          projectList: this.state.projectList
        });
      }
    );
  };

  onSelectAll = e => {
    const {
      props: { updateMigrateDataAction, migrateFormData }
    } = this;
    HEADERS[0].selectAll = !HEADERS[0].selectAll;

    if (HEADERS[0].selectAll) {
      //select all
      this.setState({ projectListCount: this.state.projectList.length });
    } else {
      //unselect all
      this.setState({ projectListCount: 0 });
    }

    this.setState(
      prevState => ({
        projectList: prevState.projectList.map(val => {
          val.checked = HEADERS[0].selectAll;
          return val;
        })
      }),
      () => {
        updateMigrateDataAction({
          ...migrateFormData,
          projectList: this.state.projectList
        });
      }
    );
  };
  proponentBlur = value => {};
  render() {
    const {
      state: {
        projectList,
        targetOptions,
        sourceoptions,
        sourceAutoSuggestApiLoading,
        sourceDefaultSelected,
        targetAutoSuggestApiLoading,
        targetDefaultSelected
      },
      props: { classes = "", isProjectListLoading },
      onSelectAll,
      onToggleCheckbox,
      onSourceOptionClick,
      onTargetOptionClick,
      onTargetOptionClickStatepmg,
      onTargetAutoSuggestChange,
      onTargetAutoSuggestChangeStatepmg,
      onSourceAutoSuggestChange,
      onSourceOptionClickStatepmg,
      onSourceAutoSuggestChangeStatepmg,
      onSubmitMigrateProject
    } = this;
    const userInfo = getLocalstorage("user");
    const isStatePMG = userInfo.groupCategory === "STATE_PMG";
    const isStateDepartment = userInfo.groupCategory === "STATE_DEPARTMENT";
    return (
      <Container>
        <h4 className="migrate-project-heading">Migrate Projects</h4>
        {this.state.projectListCount !== null && (
          <div className="migration-count-div">
            <label className="migration-count">
              {this.state.projectListCount}
            </label>
          </div>
        )}

        <Row className="migrate-project-row d-flex justify-content-between align-center ml-auto mr-auto mb-4">
          <div className="from-user-input-field flex-row">
            <h6>
              From User <span className="required">*</span>
            </h6>
            <AutoSuggestSelect
              isLoading={sourceAutoSuggestApiLoading}
              defaultSelected={sourceDefaultSelected}
              name="random_name"
              options={sourceoptions}
              onChange={
                isStateDepartment || isStatePMG
                  ? onSourceAutoSuggestChangeStatepmg
                  : onSourceAutoSuggestChange
              }
              onOptionClick={
                isStateDepartment || isStatePMG
                  ? onSourceOptionClickStatepmg
                  : onSourceOptionClick
              }
              isStateDepartment={isStateDepartment}
              isStatePMG={isStatePMG}
              redBorder={true}
              onBlur={this.proponentBlur}
            />
          </div>
          <div className="to-user-input-field flex-row">
            <h6>
              To User <span className="required">*</span>
            </h6>
            <AutoSuggestSelect
              isLoading={targetAutoSuggestApiLoading}
              defaultSelected={targetDefaultSelected}
              name="random_name"
              options={targetOptions}
              onChange={
                isStateDepartment || isStatePMG
                  ? onTargetAutoSuggestChangeStatepmg
                  : onTargetAutoSuggestChange
              }
              onOptionClick={
                isStateDepartment || isStatePMG
                  ? onTargetOptionClickStatepmg
                  : onTargetOptionClick
              }
              isStateDepartment={isStateDepartment}
              isStatePMG={isStatePMG}
              redBorder={true}
              onBlur={this.proponentBlur}
            />
          </div>
        </Row>
        {isValidArray(projectList) ? (
          <div className="model-container-table-container ml-auto mr-auto d-flex">
            <TableTemplate
              isLoading={isProjectListLoading}
              headersOptions={HEADERS}
              bodyOptions={projectList}
              classes="migrate_table animated fadeIn mb-0"
              bodyTemplate={(options, index) => (
                <>
                  <td className="animated fadeIn">
                    <Form.Check
                      className={`form-checkbox ${
                        options.checked ? "checked" : ""
                      }`}
                    >
                      <Form.Check.Input type="checkbox" />
                      <Form.Check.Label
                        className="d-flex"
                        onClick={() => onToggleCheckbox(index)}
                      />
                    </Form.Check>
                  </td>
                  <td className="animated fadeIn">
                    <Link
                      to={{
                        pathname: PATHS.PROJECT_DETAILS,
                        search: `?projectId=${options.id}`,
                        state: {
                          projectId: options.id,
                          isEdit: false
                        }
                      }}
                    >
                      {options.displayId}
                    </Link>
                    <div>{options.name} </div>
                  </td>
                  <td className="animated fadeIn">{options.sector}</td>
                  <td className="animated fadeIn">{options.status}</td>
                  <td className="animated fadeIn">
                    {dateFormat(options.createdDate)}
                  </td>
                </>
              )}
              headersTemplate={options => (
                <>
                  <th className="animated fadeIn">
                    {options.checkbox ? (
                      <Form.Check
                        className={`form-checkbox ${
                          options.selectAll ? "checked" : ""
                        }`}
                      >
                        <Form.Check.Input type="checkbox" />
                        <Form.Check.Label
                          className="d-flex"
                          onClick={onSelectAll}
                        />
                      </Form.Check>
                    ) : (
                      options.title
                    )}
                  </th>
                </>
              )}
            />
          </div>
        ) : null}
      </Container>
    );
  }
}

function mapStateToProps(state) {
  return {
    isProjectListLoading: state.userManagementReducer.isProjectListLoading,
    isProjectMigrating: state.userManagementReducer.isProjectMigrating,
    projectList: state.userManagementReducer.projectList,
    migrateFormData: state.userManagementReducer.migrateFormData
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getMigrateProjectListAction,
      migrateProjectAction,
      clearMigrateDataAction,
      updateMigrateDataAction
    },
    dispatch
  );
}

const MigrateProjectComponent = PermissionHOC(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(MigrateProject)
);
export { MigrateProjectComponent };
